export default "__VITE_ASSET__68dddc37__"